import React, { useState } from 'react';
import { SearchIcon } from 'lucide-react';
import SubmissionCard from '../components/SubmissionCard';
import { submissions } from '../utils/mockData';
const IndividualSubmissions = () => {
  const [filter, setFilter] = useState('all');
  const filteredSubmissions = filter === 'all' ? submissions : filter === 'treaty' ? submissions.filter(submission => submission.treatyRelevant) : submissions.filter(submission => submission.priority === filter);
  return <div data-id="element-154">
      <div className="mb-6" data-id="element-155">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-156">
          Individual Submissions
        </h1>
        <p className="mt-1 text-sm text-gray-600" data-id="element-157">
          Detailed review of submissions
        </p>
      </div>
      <div className="mb-6 bg-white rounded-lg shadow p-5" data-id="element-158">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-159">
          <div className="relative rounded-md w-full md:w-96" data-id="element-160">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-161">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-162" />
            </div>
            <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search submissions..." data-id="element-163" />
          </div>
          <select className="block w-full md:w-auto pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={filter} onChange={e => setFilter(e.target.value)} data-id="element-164">
            <option value="all" data-id="element-165">All Submissions</option>
            <option value="critical" data-id="element-166">Critical Priority</option>
            <option value="high" data-id="element-167">High Priority</option>
            <option value="medium" data-id="element-168">Medium Priority</option>
            <option value="low" data-id="element-169">Low Priority</option>
            <option value="treaty" data-id="element-170">Treaty Relevant</option>
          </select>
        </div>
      </div>
      <div className="mb-4" data-id="element-171">
        <p className="text-sm text-gray-500" data-id="element-172">
          Showing {filteredSubmissions.length} of {submissions.length}{' '}
          submissions
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-173">
        {filteredSubmissions.map((submission, index) => <SubmissionCard key={index} id={submission.id} submitter={submission.submitter} stakeholderType={submission.stakeholderType} date={submission.date} excerpt={submission.excerpt} themes={submission.themes} priority={submission.priority as any} confidence={submission.confidence} treatyRelevant={submission.treatyRelevant} data-id="element-174" />)}
      </div>
      {filteredSubmissions.length === 0 && <div className="text-center py-12" data-id="element-175">
          <p className="text-gray-500" data-id="element-176">
            No submissions match your current filters.
          </p>
        </div>}
    </div>;
};
export default IndividualSubmissions;